import { incentiveClaimTypes } from "../../config/applicationStatusConfig";
import { installmentsTypes } from "../../config/appliedSchemesConfig";
import {
  capitalSubsidySecondInstallmentDocuments,
  checkboxDetails,
  insertAssistanceDocuments,
  insterstSubsidyBankDetailsFieldsFirstInstallment,
  insterstSubsidyBankDetailsFieldsSecondInstallment,
  insterstSubsidyBankDetailsFieldsThirdInstallment,
  LAND_TYPES,
  landFieldGroups,
} from "../../config/incentiveClaimFormUtils";
import { formatDate } from "../../utils/utils";
import DataFormField from "../common/DataFormField";
import SectionHeading from "../common/SectionHeading";
import TableInput from "../common/TableInput";

const IncentiveClaimFormSubSection = ({
  sectionHeading,
  sectionFields,
  formData,
  handleChange,
  handleBlur,
  handleTableChange,
  errors = {},
  setFormData,
  tourismOptions,
  nicOptions,
  tehsilOptions,
  pendingDocIds,
  investClaimId = null,
  installmentType = null,
  language = false,
  applicationId = null,
}) => {
  const shouldDisableAll =
    installmentType === installmentsTypes.second.value ||
    installmentType === installmentsTypes.third.value ||
    String(investClaimId) === incentiveClaimTypes.interestassistance.value;

  const t = (val) =>
    typeof val === "object" ? (language ? val.hi : val.en) : val;

  return (
    <>
      <SectionHeading>{sectionHeading}</SectionHeading>
      {sectionFields.map((field, index) => {
        const fieldName = field.inputProps.name;
        const landType = formData.land_type;

        const capitalSubsidySecondInstallmentDoc =
          capitalSubsidySecondInstallmentDocuments.includes(fieldName);

        const interestassistanceDoc =
          insertAssistanceDocuments.includes(fieldName);

        const isDisabled =
          fieldName ===
            "loan_interest_details_interest_subsidy_first_installment" &&
          String(investClaimId) ===
            incentiveClaimTypes.interestassistance.value &&
          installmentType === installmentsTypes.first.value
            ? false
            : fieldName ===
                  "loan_interest_details_interest_subsidy_second_installment" &&
                String(investClaimId) ===
                  incentiveClaimTypes.interestassistance.value &&
                installmentType === installmentsTypes.second.value
              ? false
              : fieldName ===
                    "loan_interest_details_interest_subsidy_third_installment" &&
                  String(investClaimId) ===
                    incentiveClaimTypes.interestassistance.value &&
                  installmentType === installmentsTypes.third.value
                ? false
                : shouldDisableAll &&
                    !capitalSubsidySecondInstallmentDoc &&
                    !interestassistanceDoc
                  ? true
                  : field.inputProps.disabled || false;

        if (fieldName === "total_capital_expenditure_amount") {
          return null;
        }

        if (
          capitalSubsidySecondInstallmentDoc &&
          (installmentType === installmentsTypes.first.value ||
            String(investClaimId) ===
              incentiveClaimTypes.interestassistance.value)
        ) {
          return null;
        }

        // if (
        //   fieldName
        //     .toLowerCase()
        //     .includes("itr_document_for_interest_assistance") &&
        //   String(investClaimId) ===
        //     incentiveClaimTypes.sreimbursementcapitalincentive.value
        // ) {
        //   return null;
        // }

        // if (
        //   fieldName === "itr_document_for_capital_subsidy_second_installment" &&
        //   String(investClaimId) === incentiveClaimTypes.interestassistance.value
        // ) {
        //   return null;
        // }

        // if (
        //   fieldName ===
        //     "itr_document_for_interest_assistance_third_installment" &&
        //   String(investClaimId) ===
        //     incentiveClaimTypes.interestassistance.value &&
        //   installmentType !== installmentsTypes.third.value
        // ) {
        //   return null;
        // }

        if (fieldName === "gender") {
          const nature = formData.nature_of_organization;
          if (
            !nature ||
            (nature !== "Proprietorship Firm" &&
              nature !== "One Person Company")
          ) {
            return null; // hide Gender
          }
        }

        if (
          (insertAssistanceDocuments.includes(fieldName) ||
            insterstSubsidyBankDetailsFieldsFirstInstallment.includes(
              fieldName,
            ) ||
            insterstSubsidyBankDetailsFieldsSecondInstallment.includes(
              fieldName,
            ) ||
            insterstSubsidyBankDetailsFieldsThirdInstallment.includes(
              fieldName,
            )) &&
          String(investClaimId) !== incentiveClaimTypes.interestassistance.value
        ) {
          return null;
        }

        if (
          (insterstSubsidyBankDetailsFieldsSecondInstallment.includes(
            fieldName,
          ) ||
            insterstSubsidyBankDetailsFieldsThirdInstallment.includes(
              fieldName,
            )) &&
          String(investClaimId) ===
            incentiveClaimTypes.interestassistance.value &&
          installmentType === installmentsTypes.first.value
        ) {
          return null;
        }

        if (
          insterstSubsidyBankDetailsFieldsThirdInstallment.includes(
            fieldName,
          ) &&
          String(investClaimId) ===
            incentiveClaimTypes.interestassistance.value &&
          installmentType === installmentsTypes.second.value
        ) {
          return null;
        }

        if (fieldName === "use_same_details_as_term_loan") {
          const termLoanDetails = formData.term_loan_details;

          // Hide if empty or not an array
          if (!Array.isArray(termLoanDetails) || termLoanDetails.length === 0) {
            return null;
          }
        }

        if (
          fieldName === "investment_certificate" &&
          !formData?.investment_certificate?.url
        ) {
          return null;
        }

        // --- Land type handling ---
        if (landFieldGroups.all.includes(fieldName)) {
          // Only apply hiding rules if this field is one of the land-related fields
          if (!landType) {
            return null; // nothing selected → hide all
          }

          if (landType === LAND_TYPES.OWN) {
            return null; // hide all land fields for Own Land
          }

          if (
            landType === LAND_TYPES.PURCHASED &&
            !landFieldGroups.purchased.includes(fieldName)
          ) {
            return null; // show only purchased group
          }

          if (
            (landType === LAND_TYPES.LEASE_OR_RENTAL ||
              landType === LAND_TYPES.GOVERNMENT_ALLOTTED) &&
            !landFieldGroups.leaseOrGovt.includes(fieldName)
          ) {
            return null; // show only lease/govt group
          }
        }

        // --- Checkbox-driven detail tables ---
        const controllingField = checkboxDetails[fieldName];
        const isChecked =
          formData[controllingField] === true ||
          formData[controllingField] === "1";
        if (controllingField && !isChecked) {
          return null; // hide details table if checkbox unchecked
        }

        if (field.inputProps.type === "table") {
          const tableName = field.inputProps.name;

          let currentRows = formData[tableName] || [];

          if (typeof currentRows === "string") {
            try {
              const parsed = JSON.parse(currentRows);
              currentRows = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              currentRows = [];
            }
          }

          const rowsToUse =
            currentRows.length > 0 ? currentRows : field.inputProps.rows || [];

          return (
            <TableInput
              key={index}
              htmlFor={field.htmlFor}
              label={t(field?.label)}
              namePrefix={tableName}
              divClass="w-full px-2 mb-6 max-w-full overflow-x-auto"
              tableClass={field.inputProps.tableClass}
              headerBg={field.inputProps.headerBg}
              headerClass={field.inputProps.headerClass}
              rowClass={field.inputProps.rowClass}
              headers={field.inputProps.headers}
              canAddMore={field.inputProps.canAddMore}
              rows={rowsToUse}
              onChange={(newRows, isNewRow, rowIndex, fieldName, rowRemoved) =>
                handleTableChange(
                  tableName,
                  newRows,
                  isNewRow,
                  rowIndex,
                  fieldName,
                  rowRemoved,
                )
              }
              errors={errors}
              formData={formData}
              setFormData={setFormData}
              tableDisabled={isDisabled}
              language={language}
              applicationId={applicationId}
            />
          );
        }

        return (
          <DataFormField
            key={index}
            labelClass={
              field.inputProps.type === "file" &&
              pendingDocIds?.includes(
                String(formData[field.inputProps.name]?.docTypeId),
              )
                ? "text-red-500"
                : "text-sm"
            }
            divClass={field.divClass}
            label={t(field?.label)}
            htmlFor={field.htmlFor}
            inputClass={
              field.inputProps.type === "checkbox"
                ? "h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                : "w-full border rounded px-3 py-2 text-sm"
            }
            error={errors[field.inputProps.name]}
            inputProps={{
              required: field.inputProps.required || "false",
              type: field.inputProps.type || "text",
              name: field.inputProps.name,
              id: field.inputProps.name,
              placeholder: t(field.inputProps.placeholder) || "",
              disabled: isDisabled || false,
              value:
                field.inputProps.type === "date"
                  ? formatDate(formData[field.inputProps.name])
                  : field.inputProps.type === "checkbox"
                    ? undefined // ✅ checkboxes don’t need value
                    : formData[field.inputProps.name] || "",
              checked:
                field.inputProps.type === "checkbox"
                  ? formData[field.inputProps.name] === true ||
                    formData[field.inputProps.name] === "1" ||
                    formData[field.inputProps.name] === 1
                  : undefined,
              onChange: handleChange,
              onBlur: handleBlur,
              options:
                field.inputProps.name === "tourism_product_name"
                  ? tourismOptions
                  : field.inputProps.name === "nic_code"
                    ? nicOptions
                    : field.inputProps.name === "land_tehsil"
                      ? tehsilOptions
                      : field.inputProps.options || [],
              maxLength: field.inputProps.maxLength || 255,
              ...(field.inputProps.min ? { min: field.inputProps.min } : {}),
              ...(field.inputProps.max ? { max: field.inputProps.max } : {}),
              description: t(field.inputProps.description),
              formatDocument: field.inputProps.formatDocument || null,
            }}
            formData={formData}
            language={language}
          />
        );
      })}
    </>
  );
};

export default IncentiveClaimFormSubSection;
